/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIProviderQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AIProviderQueryOperator");
    }

    getFixupPrototypeFunction() { return AIProviderQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AIProviderQueryOperator>): AIProviderQueryOperator {
        let obj = Object.assign(new AIProviderQueryOperator(), model);
        AIProviderQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIProviderQueryOperator>): AIProviderQueryOperator {
        if (!model) return null;
        return AIProviderQueryOperator.newInstance(<AIProviderQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIProviderQueryOperator) {
        if (!obj) return;

        models.AIProviderQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIProviderQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIProviderQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * AI providers to include
     */
    provider_names: Array<models.AIProviderName>;

}
